import '.ba{position:fixed;}.ssr-plugin'
import '.bb{inset:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.ds{background-color:rgba(0,0,0,0.3);}.ssr-plugin'
import '.s{padding:16px;}.ssr-plugin'
import '.dt{z-index:1;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.du{max-width:600px;}.ssr-plugin'
import '.d7{border-radius:16px;}.ssr-plugin'
import '.dv{z-index:2;}.ssr-plugin'
import '.dw{height:90vh;}.ssr-plugin'
import '.dx{max-height:720px;}.ssr-plugin'
import '.a7{position:relative;}.ssr-plugin'
import '.bc{overflow:hidden;}.ssr-plugin'
import '.dy{padding-bottom:96px;}.ssr-plugin'
import '.ag{justify-content:space-between;}.ssr-plugin'
import '.dz{padding:32px 16px 16px 16px;}.ssr-plugin'
import '.j{border:none;}.ssr-plugin'
import '.e0{background-color:transparent;}.ssr-plugin'
import '.e1{aspect-ratio:1/1;}.ssr-plugin'
import '.e2{width:32px;}.ssr-plugin'
import '.k{cursor:pointer;}.ssr-plugin'
import '.e3{padding:6px;}.ssr-plugin'
import '.e4{border-radius:4px;}.ssr-plugin'
import '.e5{padding-left:16px;}.ssr-plugin'
import '.e6{padding-right:16px;}.ssr-plugin'
import '.c0{overflow-y:scroll;}.ssr-plugin'
import '.e7{max-height:540px;}.ssr-plugin'
import '.e8{text-align:right;}.ssr-plugin'
import '.an{position:absolute;}.ssr-plugin'
import '.di{left:0px;}.ssr-plugin'
import '.dk{right:0px;}.ssr-plugin'
import '.aw{bottom:0px;}.ssr-plugin'
import React, { useEffect } from 'react'
import { styled } from 'inlines'
import { Text } from './Text'
import { Button } from './Button'
import { useTheme } from '../providers/useTheme'
import { useIsMobile } from '../hooks/useIsMobile'
import { useTranslations } from '../hooks/useTranslations'
import { Html } from './Html'

export const TermsModal = ({ setShowTermsModal }) => {
  const { colors } = useTheme()
  const isMobile = useIsMobile()

  const { data: navDic = {} } = useTranslations('navigation')
  const { data: legalDic = {} } = useTranslations('legal')

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <div className="ba bb a d c ds s dt"
      onClick={() => setShowTermsModal(false)}
    >
      <div className="f du d7 dv dw dx a7 bc dy"
        style={{
          background: colors.background,}}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="a d ag dz"
        >
          <Text variant="subtitle" color="gradient" style={{ fontWeight: 700 }}>
            {navDic.terms_and_conditions_title}
          </Text>
          <styled.button className="j e0 e1 e2 a d c k e3 e4"
            style={{
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.06)',
              },
            }}
            onClick={() => setShowTermsModal(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
            >
              <path
                d="M6.1135 6.82125L0.86725 12.0672C0.77375 12.1609 0.659 12.2109 0.523 12.2172C0.387167 12.2238 0.266083 12.1737 0.15975 12.0672C0.05325 11.9609 0 11.843 0 11.7135C0 11.584 0.05325 11.4661 0.15975 11.3597L5.40575 6.1135L0.15975 0.86725C0.0660833 0.77375 0.0160833 0.659 0.00974999 0.523C0.00324999 0.387166 0.05325 0.266082 0.15975 0.159749C0.266083 0.0532488 0.384 0 0.5135 0C0.643 0 0.760916 0.0532488 0.86725 0.159749L6.1135 5.40575L11.3597 0.159749C11.4532 0.0660822 11.568 0.0160822 11.704 0.00974884C11.8398 0.00324884 11.9609 0.0532488 12.0673 0.159749C12.1737 0.266082 12.227 0.383999 12.227 0.513499C12.227 0.642999 12.1737 0.760917 12.0673 0.86725L6.82125 6.1135L12.0673 11.3597C12.1609 11.4532 12.2109 11.568 12.2172 11.704C12.2238 11.8398 12.1737 11.9609 12.0673 12.0672C11.9609 12.1737 11.843 12.227 11.7135 12.227C11.584 12.227 11.4661 12.1737 11.3597 12.0672L6.1135 6.82125Z"
                fill={colors.textPrimary}
                fillOpacity="0.6"
              />
            </svg>
          </styled.button>
        </div>

        <div className="e5 e6 c0 e7"
          style={{
            marginBottom: isMobile ? '96px' : '32px',}}
        >
          <Html color={colors.textSecondary} variant="subheading-regular">
            {legalDic.terms_and_conditions}
          </Html>
        </div>
        <div className="s e8 an di dk aw"
          style={{
            borderTop: `1px solid ${colors.border}`,
            background: colors.background,}}
        >
          <Button
            id="modal-terms-close"
            on={{
              click: () => setShowTermsModal(false),
            }}
            style={{ width: isMobile ? '100%' : 'inherit' }}
          >
            <Text color={colors.background} variant="display-medium">
              {navDic.close_button}
            </Text>
          </Button>
        </div>
      </div>
    </div>
  )
}
